import Parse from 'parse/dist/parse.min.js';

let patched = false;

export const patchParseFileURLs = () => {
	if (patched) return;
	patched = true;

	const decode = Parse.File.fromJSON.bind(Parse.File);
	Parse.File.fromJSON = (json) => {
		const file   = decode(json);
		const marker = `/files/${Parse.applicationId}/`;
		const at     = file._url ? file._url.indexOf(marker) : -1;
		// Anything that is not one of our file URLs stays untouched, and
		// the name is copied verbatim because it is already URL-encoded.
		if (at < 0) return file;
		const name = file._url.substring(at + marker.length);
		file._url  = Parse.serverURL + marker + name;
		return file;
	};
};
